/* aBeauty, Black Friday Games 2026: starea paginii, reveal, numărătoare, dataLayer, atribute de coș.
   Încărcat DOAR de sections/abeauty-bfg.liquid. Vanilla, fără dependențe, sub 8 KB.
   ⛔ NU deblochează nimic local: ofertele zilei curente sunt deja în HTML (în .bfg-reveal[hidden]);
      zilele viitoare nu au nimic în HTML, deci nu există ce arăta.
   Contractul unui joc (assets/bfg-game-<nume>.js): window.BFG.games[nume] = function (opts) -> {reset, lock, isDone}
   cu opts = {board, msg, status, live (id-uri), reduced, onStart(), onFinish(rezultat)}.
   Atributele de coș `_bfg_day` / `_bfg_game` se scriu DOAR cu Shopify.customerPrivacy.marketingAllowed() === true
   (tiparul oppref, 08.09.2026): null = nu a ales încă, nu scriem nimic. */
(function () {
  "use strict";
  var reduced = window.matchMedia && window.matchMedia("(prefers-reduced-motion: reduce)").matches;
  var root = document.querySelector("[data-bfg]");

  function dl(ev, extra) {
    try {
      window.dataLayer = window.dataLayer || [];
      var o = { event: ev };
      for (var k in extra) if (extra[k] !== undefined && extra[k] !== "") o[k] = extra[k];
      window.dataLayer.push(o);
      // GA4 direct, prin tagul Google deja încărcat de GTM (G-5SM186S8C2), cu destinatar explicit: fără `send_to`
      // tagul din GTM ignoră comanda (măsurat 11.10). Consimțământul îl aplică tagul (Consent Mode), ca la orice
      // tag Google. Adspirer nu poate crea declanșatoare în GTM, de aceea evenimentul pleacă de aici.
      var g = { send_to: "G-5SM186S8C2" };
      for (var j in o) if (j !== "event") g[j] = o[j];
      ga4(ev, g, 0);
    } catch (e) {}
  }
  // Un eveniment trimis înainte ca GTM să configureze destinația se pierde (bf_games_view, la încărcare): așteptăm
  // până apare G-5SM186S8C2 în google_tag_manager, cel mult 10 s, apoi îl trimitem.
  function ga4(ev, g, n) {
    var gtm = window.google_tag_manager;
    if (typeof window.gtag === "function" && gtm && gtm["G-5SM186S8C2"]) { window.gtag("event", ev, g); return; }
    if (n < 40) setTimeout(function () { ga4(ev, g, n + 1); }, 250);
  }
  window.BFG = window.BFG || {}; window.BFG.ga4 = function (ev, g) { ga4(ev, g, 0); };

  // Numărătoarea: termenul vine din Liquid (data-end, ISO cu offset). Ceasul clientului e folosit
  // dacă diferă de cel al serverului cu mai puțin de 10 minute (fereastra de cache a paginii),
  // altfel se corectează cu decalajul.
  function pad(n) { return (n < 10 ? "0" : "") + n; }
  var counters = [].slice.call(document.querySelectorAll("[data-countdown]"));
  var offset = 0;
  if (counters.length) {
    var srv = Number(counters[0].getAttribute("data-server-now")) * 1000;
    if (srv && Math.abs(srv - Date.now()) > 600000) offset = srv - Date.now();
  }
  function renderCount() {
    counters.forEach(function (el) {
      var end = Date.parse(el.getAttribute("data-end"));
      if (!end) return;
      var left = end - (Date.now() + offset);
      var label = el.getAttribute("data-label") || "";
      if (left <= 0) { el.textContent = "s-a încheiat"; return; }
      var d = Math.floor(left / 86400000), h = Math.floor(left / 3600000) % 24, m = Math.floor(left / 60000) % 60, s = Math.floor(left / 1000) % 60;
      el.innerHTML = (label ? '<span class="bfg__count-label">' + label + "</span>" : "") +
        (d ? d + "<small>" + (d === 1 ? "zi" : "zile") + "</small>" : "") +
        pad(h) + "<small>ore</small>" + pad(m) + "<small>min</small>" + pad(s) + "<small>sec</small>";
    });
  }
  if (counters.length) { renderCount(); setInterval(renderCount, reduced ? 60000 : 1000); }

  if (!root) return;
  var day = root.getAttribute("data-bfg-day") || "";
  var game = root.getAttribute("data-bfg-game") || "";
  var state = root.getAttribute("data-bfg-state") || root.getAttribute("data-bfg-mode") || "";
  var base = { bfg_day: day, bfg_game: game, bfg_state: state };
  dl("bf_games_view", base);

  function marketingAllowed() {
    try {
      var api = window.Shopify && window.Shopify.customerPrivacy;
      if (!api || typeof api.marketingAllowed !== "function") return null;
      return api.marketingAllowed() === true;
    } catch (e) { return null; }
  }
  function cartRoot() {
    try { return (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || "/"; } catch (e) { return "/"; }
  }
  var cartDone = false;
  function cartAttrs() {
    if (cartDone || !day || marketingAllowed() !== true) return;
    cartDone = true;
    fetch(cartRoot() + "cart.js", { credentials: "same-origin" }).then(function (r) { return r.json(); }).then(function (c) {
      var cur = (c && c.attributes) || {};
      if (cur._bfg_day === day && cur._bfg_game === game) return;
      return fetch(cartRoot() + "cart/update.js", { method: "POST", credentials: "same-origin",
        headers: { "Content-Type": "application/json" }, body: JSON.stringify({ attributes: { _bfg_day: day, _bfg_game: game } }) });
    }).catch(function () { cartDone = false; });
  }

  root.addEventListener("click", function (e) {
    var a = e.target.closest ? e.target.closest("a[data-offer], a[data-bfg-cta]") : null;
    if (!a) return;
    dl("bf_games_offer_click", { bfg_day: day, bfg_game: game, item_id: a.getAttribute("data-offer") || "cta" });
    cartAttrs();
  });

  var gameEl = document.getElementById("bfg-game");
  if (!gameEl) return;
  var reveal = document.getElementById("bfg-reveal");
  var revealH = document.getElementById("bfg-reveal-h");
  var skip = document.getElementById("bfg-skip");
  var again = document.getElementById("bfg-again");
  var live = document.getElementById("bfg-live");
  var instance = null, started = false, revealed = false;

  function say(t) { if (live) live.textContent = t; }
  function openReveal(reason) {
    if (instance && instance.lock) instance.lock();
    if (skip) skip.disabled = true;
    if (revealed) return;
    revealed = true;
    if (reveal) {
      // ofertele sunt deja vizibile; finalul jocului (sau „Vezi ofertele zilei”) derulează la ele, cu un mic moment de sărbătoare
      reveal.hidden = false;
      reveal.classList.add("bfg-reveal--fresh");
      dl("bf_games_reveal", { bfg_day: day, bfg_game: game, bfg_reason: reason });
      cartAttrs();
      var target = revealH || reveal;
      setTimeout(function () {
        reveal.scrollIntoView({ behavior: reduced ? "auto" : "smooth", block: "start" });
        try { target.setAttribute("tabindex", "-1"); target.focus({ preventScroll: true }); } catch (e) {}
      }, reason === "skip" ? 0 : 450);
    }
    if (reason === "skip") say("Ai sărit peste joc. Ofertele zilei sunt deschise.");
  }
  function onStart() {
    if (started) return;
    started = true;
    dl("bf_games_start", base);
  }
  function onFinish(result) {
    dl("bf_games_finish", { bfg_day: day, bfg_game: game, bfg_result: result || "done" });
    openReveal(result || "done");
  }
  function boot() {
    var init = window.BFG && window.BFG.games && window.BFG.games[game];
    if (typeof init !== "function") { say("Jocul nu s-a încărcat. Ofertele se deschid cu butonul."); return; }
    instance = init({ board: "bfg-board", msg: "bfg-msg", status: "bfg-status", live: "bfg-live", reduced: reduced, onStart: onStart, onFinish: onFinish });
  }
  if (skip) skip.addEventListener("click", function () { openReveal("skip"); });
  if (again) again.addEventListener("click", function () {
    if (instance && instance.reset) instance.reset();
    started = false;
    if (skip && !revealed) skip.disabled = false;
    say("Jocul a fost luat de la capăt.");
  });
  // Scriptul jocului e tot `defer`, pus în DOM înaintea acestuia: a rulat deja. Plasă: DOMContentLoaded.
  // Fontul de mână (Caveat) se încarcă ÎNAINTE de pornirea jocului: Phaser desenează cifrele o singură dată, în textură,
  // iar un canvas creat înaintea fontului rămâne pe fallback. Plafon 1,5 s, ca jocul să nu aștepte un font care nu vine.
  function bootCuFont() {
    var gata = false; var porneste = function () { if (!gata) { gata = true; boot(); } };
    try {
      if (document.fonts && document.fonts.load) {
        Promise.all([document.fonts.load('700 40px "Caveat"'), document.fonts.load('400 24px "Caveat"')]).then(porneste, porneste);
        setTimeout(porneste, 1500); return;
      }
    } catch (e) {}
    porneste();
  }
  if (document.readyState === "loading") document.addEventListener("DOMContentLoaded", bootCuFont); else bootCuFont();
})();
